import { setWasmUrl } from '@lottiefiles/dotlottie-react';

/**
 * Self-host the dotlottie WASM runtime renderer instead of loading it from public CDN (jsDelivr).
 *
 * `@lottiefiles/dotlottie-react` exports `setWasmUrl`, which registers the runtime WASM URL
 * on both `DotLottie` and `DotLottieWorker`.
 * The WASM binary is exported as `@lottiefiles/dotlottie-web/dotlottie-player.wasm` and
 * bundled as a same-origin static asset via `new URL(..., import.meta.url)`.
 */
export const initDotLottieWasm = (): void => {
    if (typeof setWasmUrl === 'function') {
        setWasmUrl(new URL('@lottiefiles/dotlottie-web/dotlottie-player.wasm', import.meta.url).href);
    }
};

initDotLottieWasm();
